angular.module('aprima-core-ui').directive('dialHref', ['DeviceSettings', 'ClickListenerService', '$window', function (DeviceSettings, ClickListenerService, $window) {
    'use strict';

    return {
        restrict: 'A',
        scope: {
            dialHref : '=',
            dialHrefProtocol: '@'
        },
        link: function (scope, elem) {
            if (DeviceSettings.isPrm) {
                return;
            }

            elem.addClass('clickable');
            var deregister = ClickListenerService.register(elem, clickHandler, {
                hmStopPropagation: true,
            });
            scope.$on('$destroy', deregister);

            function clickHandler() {
                var protocol = scope.dialHrefProtocol || 'tel';
                $window.location.href = protocol + ':' + scope.dialHref;
            }
        }
    };
}]);
